import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'sd-toggle',
  standalone: false,
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true
    }
  ]
})
export class ToggleComponent implements ControlValueAccessor {
  @Input() disabled = false;
  value = false;

  toggle(): void {
    if (this.disabled) return;
    
    this.value = !this.value;
    this.ngOnChange(this.value);
    this.ngOnTouched();
  }

  // ControlValueAccessor interface implementation
  private ngOnChange: (value: boolean) => void = () => {};
  private ngOnTouched: () => void = () => {};
  
  writeValue(value: boolean): void {
    this.value = !!value;
  }

  registerOnChange(fn: any): void {
    this.ngOnChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.ngOnTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
